import { render, staticRenderFns } from "./LogPurgeConfig.vue?vue&type=template&id=4e1a5f44&scoped=true&"
import script from "./LogPurgeConfig.vue?vue&type=script&lang=js&"
export * from "./LogPurgeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a5f44",
  null
  
)

export default component.exports